export const MAIN_SIDE_NAV_OUTLET_NAME = 'sgMainSidenav';
